export default "__VITE_ASSET__C5MQ_jlG__"